import { jsx as E } from "react/jsx-runtime";
import { s as R } from "../../../Popover.module-DJ-RK5B3.js";
import { usePopover as k } from "../hooks/usePopover.js";
import { useCallback as f, cloneElement as F } from "react";
import { hasFocus as S } from "../helpers/hasFocus.js";
import { usePopoverActivatorInteractions as W } from "../hooks/usePopoverActivatorInteractions.js";
const M = ({
  children: c,
  disabledAutoToggle: o,
  minLength: m,
  ...h
}) => {
  const t = k(), n = c == null ? void 0 : c.props, e = m ?? n.minLength ?? 1, i = "focus", v = f(
    (s) => {
      var r;
      const a = s.currentTarget.value;
      if (!o) {
        const u = a.length >= e;
        u && (t == null ? void 0 : t.show) === !1 ? t.setShowWithReason(!0, s.nativeEvent, i) : !u && (t != null && t.show) && t.setShowWithReason(!1, s.nativeEvent, i);
      }
      (r = n.onChange) == null || r.call(n, s, a);
    },
    [n, o, e, t]
  ), l = f(
    (s) => {
      var r;
      const a = s.currentTarget.value;
      (r = n.onClick) == null || r.call(n, s), !o && (t == null ? void 0 : t.show) === !1 && S(s.currentTarget) && a.length >= e && t.setShowWithReason(!0, s.nativeEvent, i);
    },
    [n, o, e, t]
  ), w = f(
    (s) => {
      var a;
      (a = n.onFocus) == null || a.call(n, s), !o && (!e || s.currentTarget.value.length >= e) && (t == null ? void 0 : t.show) === !1 && t.setShowWithReason(!0, s.nativeEvent, "focus");
    },
    [n, o, e, t]
  ), C = W(
    t,
    n
  );
  return /* @__PURE__ */ E(
    "div",
    {
      ...h,
      className: R.activator,
      ref: t == null ? void 0 : t.api.refs.setReference,
      children: c && t && F(
        c,
        t.interactions.getReferenceProps({
          ...C,
          "aria-autocomplete": "list",
          onChange: v,
          onClick: l,
          onFocus: w
        })
      )
    }
  );
};
export {
  M as InputPopoverActivator
};
